var _path, _circle, _path2, _path3, _path4, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIllustrationBird = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 43 40"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFC38B",
  d: "m2.616 13.685 6.049-.183-1.511 4.187z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 13.216,
  cy: 15.564,
  r: 7.042,
  fill: "#FFF362",
  transform: "rotate(-19.77 13.216 15.564)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#9FDFE7",
  d: "M30 12.84a4.9 4.9 0 0 1 .716 2.107c.079.76-.008 1.551-.256 2.326a6.9 6.9 0 0 1-1.19 2.19 7.7 7.7 0 0 1-1.94 1.72 7.7 7.7 0 0 1-2.399.989 6.9 6.9 0 0 1-2.489.107 5.7 5.7 0 0 1-2.202-.79 4.9 4.9 0 0 1-1.579-1.569l5.67-3.54z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF362",
  d: "M33.635 22.623a10.515 10.515 0 0 1-16.745 5.044 10.52 10.52 0 0 1-3.37-11.189l10.058 3.073z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFC38B",
  d: "M33.333 17.44a4.9 4.9 0 0 1 .296 2.206 5.7 5.7 0 0 1-.7 2.232 6.9 6.9 0 0 1-1.589 1.92 7.7 7.7 0 0 1-2.236 1.313 7.7 7.7 0 0 1-2.544.508 6.9 6.9 0 0 1-2.463-.375 5.7 5.7 0 0 1-2.009-1.2 4.9 4.9 0 0 1-1.247-1.844l6.246-2.38z"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 10.118,
  cy: 12.87,
  r: 0.85,
  fill: "#595857",
  transform: "rotate(10.15 10.118 12.87)"
})));
export default SvgIllustrationBird;